import { Components, Theme } from "@mui/material";

export const MuiTabs: Components<Omit<Theme, "MuiTabs">>["MuiTabs"] = {
  defaultProps: {
    sx: {
      borderBottom: `1px solid #e6e4f0`,
    },
  },
};
